export default __webpack_public_path__ + "static/media/top-left-orange.f7a4a4ad.png";